module.exports = __webpack_public_path__ + "static/img/IMG_20150522_165544.abd4f4b0.jpg";